<template>
  <el-form-item :label="$t('meus-layouts')" prop="layout">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="24" :md="16" :lg="10" :xl="10">
        <el-dialog
          top="2vh"
          title="Colunas"
          :visible.sync="dialog"
          width="30%">
          <ul class="list-group">
            <li class="list-group-item" v-for="column of current" :key="column">{{ column }}</li>
          </ul>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialog = false">OK</el-button>
          </span>
        </el-dialog>  
        <el-select
          v-loading="loading"
          v-model="layout"
          placeholder="Selecione uma opção"
          clearable
        >
          <el-option
            v-for="layout in list"
            :key="layout.id"
            :label="layout.name"
            :value="layout.id"
          >
            <span style="float: left">{{ layout.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">({{ layout.fields.split(',').length }} colunas)</span>
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="10" :xl="10" v-if="layout">
        <el-button type="info" @click="open">Ver colunas</el-button>
        <el-button type="success" @click="apply">Aplicar</el-button>
        <el-button @click="remove">Remover esse layout</el-button>
      </el-col>
    </el-row>
  </el-form-item>
</template>

<script>
  import { i18n } from "@/plugin/i18n";
import { LayoutService } from "@/services/customers/layout.services";
  export default {
    props: ['type'],
    methods: {
      open() {
        const vm = this;
        const layout = vm.list.find(x => x.id === vm.layout);
        if (layout) {
          vm.current = layout.fields.split(',');
          vm.dialog = true;
        }
      },
      apply() {
        const vm = this;
        const layout = vm.list.find(x => x.id === vm.layout);
        const f = layout.fields.split(',');
        vm.$emit("apply", vm.layout, f);
      },
      remove() {
        const vm = this;
        const layout = vm.list.find(x => x.id === vm.layout);
        if (!layout) return false;

        this.$confirm(
          `Deseja remover o layout ${layout.name}?`,
          i18n.tc("aviso"),
          {
            confirmButtonText: "OK",
            cancelButtonText: i18n.tc("cancelar"),
            type: i18n.tc("aviso"),
            center: true,
          }
        ).then(() => {
          const loading = vm.$loading(vm.$options.loading);
          LayoutService.delete(layout.id)
            .then((response) => {
              vm.list.splice(
                vm.list.findIndex((x) => x.id === layout.id),
                1
              );
              vm.layout = '';
              this.$message({
                type: "success",
                message: "Layout removido com sucesso!",
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
          });
      },
      fetch() {
        const vm = this;
        vm.loading = true;
        setTimeout(() => {
          LayoutService.type(vm.type).then(response => {
            vm.list = response.records;
          }).finally(() => vm.loading = false);
        }, 200)
      }

    },
    data() {
      return {
        layout: '',
        loading: false,
        current: [],
        dialog: false,
        list: [],
      }
    },
    mounted() {
      const vm = this;
      vm.fetch();
    },
  }
</script>
